module.exports = __webpack_public_path__ + "static/pic02-12bb8bfcaef30d715b698e373a02e901.jpg";